import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SlipEvent } from "../../models/jackpot";

const initialState: SlipEvent[] = [];

export const gamesSlice = createSlice({
  name: "gameSlice",
  initialState,
  reducers: {
    addGames: (state: SlipEvent[], action: PayloadAction<SlipEvent>) => {
      // eslint-disable-next-line no-param-reassign
      state = [...state, action.payload];
      return state;
    },
    deleteGame: (state: SlipEvent[], action: PayloadAction<number>) => {
      state.splice(action.payload, 1);
      return state;
    },
    modifyGames: (state: SlipEvent[], action: PayloadAction<SlipEvent[]>) => {
      // eslint-disable-next-line no-param-reassign
      state = action.payload;
      return state;
    },
    deleteGames: (state: SlipEvent[]) => {
      // eslint-disable-next-line no-param-reassign
      state = initialState;
      return state;
    },
  },
});

export const { addGames, deleteGames, modifyGames, deleteGame } =
  gamesSlice.actions;

export default gamesSlice.reducer;
